<div class="fh-modal" role="dialog" aria-modal="true" aria-labelledby="rule-modal-title">
  <div class="fh-modal-backdrop" (click)="closed.emit()"></div>
  <div class="fh-modal-panel">
    <div class="fh-modal-head">
      <span class="line-tile" [ngClass]="tone"><i class="bi bi-patch-check"></i></span>
      <div class="flex-grow-1 min-w-0">
        <div class="small text-muted-fh text-truncate">{{ service.name }} · {{ product.name }}</div>
        <h2 id="rule-modal-title" class="h5 fw-semibold mb-0">Prezzo in convenzione</h2>
        <div class="small text-muted-fh">Prodotto #{{ product.id }}</div>
      </div>
      <button type="button" class="icon-btn" (click)="closed.emit()" aria-label="Chiudi">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="fh-modal-body">
      <form [formGroup]="form" (ngSubmit)="submit()" class="row g-3">
        <div class="col-12">
          <span class="form-label d-block">Modalità</span>
          <div class="segmented">
            <button
              type="button"
              *ngFor="let m of modes"
              [class.active]="form.get('pricingMode')?.value === m"
              (click)="setMode(m)"
            >
              <i class="bi me-1" [ngClass]="m === 'HOURLY' ? 'bi-clock' : 'bi-ticket-perforated'"></i>{{ unitOf(m).label }}
            </button>
          </div>
        </div>

        <div class="col-sm-6">
          <label class="form-label" for="rule-min">{{ hourly ? 'Tariffa minima' : 'Costo a ' + unit.unit }}</label>
          <div class="input-group">
            <span class="input-group-text">€</span>
            <input id="rule-min" type="number" min="0" step="0.5" class="form-control text-end" formControlName="minPrice" />
            <span *ngIf="hourly" class="input-group-text">/ora</span>
          </div>
          <span class="form-error" *ngIf="(form.get('minPrice')?.touched || formInvalid) && form.get('minPrice')?.invalid">
            Inserisci un importo valido
          </span>
        </div>
        <div *ngIf="hourly" class="col-sm-6">
          <label class="form-label" for="rule-max">Tariffa massima</label>
          <div class="input-group">
            <span class="input-group-text">€</span>
            <input id="rule-max" type="number" min="0" step="0.5" class="form-control text-end" formControlName="maxPrice" placeholder="= minima" />
            <span class="input-group-text">/ora</span>
          </div>
          <span class="form-error" *ngIf="form.errors?.['range']">La massima non può essere sotto la minima</span>
        </div>

        <div class="col-sm-6">
          <label class="form-label" for="rule-qty">{{ unit.units | titlecase }} {{ freePrice ? 'gratuite' : 'scontate' }}</label>
          <input id="rule-qty" type="number" min="0" step="1" class="form-control text-end" formControlName="quantity" placeholder="—" />
        </div>
        <div class="col-12">
          <span class="hint d-block">
            <ng-container *ngIf="hourly; else fixedHint">
              La tariffa esatta si decide sulla singola richiesta, dentro questo intervallo. Lascia vuota la massima per
              una tariffa unica.
            </ng-container>
            <ng-template #fixedHint>Costo fisso per ogni {{ unit.unit }}.</ng-template>
            Per ora la convenzione è solo informativa: non cambia pagamenti né richieste.
          </span>
        </div>
      </form>

      <div *ngIf="confirmRemove" class="notice mt-3">
        <i class="bi bi-exclamation-triangle me-1"></i>
        {{ product.name }} non sarà più nella convenzione. Premi «Conferma» per procedere.
      </div>
      <div *ngIf="errorText" class="alert alert-danger small mt-3 mb-0">{{ errorText }}</div>
    </div>

    <div class="fh-modal-foot">
      <button *ngIf="rule" type="button" class="danger-link" [disabled]="saving" (click)="remove()">
        <i class="bi bi-x-circle me-1"></i>{{ confirmRemove ? 'Conferma' : 'Togli dalla convenzione' }}
      </button>
      <span *ngIf="!rule" class="hint">Importi in euro, salvati in centesimi.</span>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-light" (click)="closed.emit()">Annulla</button>
        <button type="button" class="btn btn-primary text-light" [disabled]="saving" (click)="submit()">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>Salva
        </button>
      </div>
    </div>
  </div>
</div>
